module.exports = __webpack_public_path__ + "assets/img/34_760.cc32b5bd.jpg";